<div class="container-fluid animated fadeIn">
	<div class="row flex-column align-items-center my-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title text-center">
				{{ 'supplier-upload.pageTitle' | translate }}
			</div>
		</div>
		<!-- CARD -->
		<div class="col-12 col-xl-12">
			<eif-custom-stepper
				[steps]="steps"
				[currentStep]="currentStep">
			</eif-custom-stepper>

			<div class="simple-card top-line">
				<div class="row justify-content-center px-3 py-3 px-md-5 py-md-5">
					<div class="d-flex justify-content-center align-items-center valid-results">
						<div
							class="d-inline-flex align-items-center"
							[class.are-valid]="totalValidRecords > 0"
							[class.are-invalid]="totalValidRecords === 0">
							<div>
								<div class="info-img-wrap">
									@if (totalValidRecords > 0) {
										<div>
											<i class="fa-solid fa-check-circle"></i>
										</div>
									} @else {
										<div>
											<i class="fa-solid fa-times-circle"></i>
										</div>
									}
								</div>
							</div>
							<div class="ms-4">
								<div class="text-uppercase text-secondary">
									<span>{{ 'supplier-upload-step4.FinalSupplierOutcomeText1' | translate }}</span>
									<span
										class="tag mx-2 fw-bold"
										[class.is-success]="totalValidRecords > 0"
										[class.is-danger]="totalValidRecords === 0"
										data-e2e-suppliers-upload-step4-valid-total>
										{{ totalValidRecords }}
									</span>
									<span>{{ 'supplier-upload-step4.FinalSupplierOutcomeText2' | translate }}</span>
									<span
										class="tag is-light mx-2"
										data-e2e-suppliers-upload-step4-documents-total>
										{{ totalValidRecords + totalInvalidRecords }}
									</span>
									<span>{{ 'supplier-upload-step4.FinalSupplierOutcomeText3' | translate }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				@if (totalInvalidRecords > 0) {
					<div>
						<div class="divider"></div>
						<div class="p-4">
							<div class="py-3">
								<h6 class="fw-bold is-font-sm">{{ 'supplier-upload-step4.InvalidSuppliersList' | translate }}</h6>
							</div>
							<div class="table-responsive">
								@if (showValidationResults) {
									<eif-suppliers-upload-validation-result
										[validationResultRecords]="invalidSupplierRecords"
										[showColumnActiveAutomaticFundingRequest]="showColumnActiveAutomaticFundingRequest"
										class="validation-result-table"></eif-suppliers-upload-validation-result>
								}
							</div>
						</div>
					</div>
				}
			</div>
			<!-- BUTTONS AREA -->
			<div class="d-flex align-items-center justify-content-xs-center justify-content-end p-4">
				<div>
					<eif-custom-button
						[text]="'button.back' | translate"
						[color]="'neutral'"
						[class]="'mb-0'"
						(action)="backToValidationStep()">
					</eif-custom-button>
				</div>
				<div>
					<eif-custom-button
						[text]="'supplier-upload-step4.goToInvitationsSearch' | translate"
						[class]="'mb-0 ms-2'"
						(action)="goToInvitationsSearch()">
					</eif-custom-button>
				</div>
			</div>
		</div>
	</div>
</div>
